export const isValidEmail = email => Boolean(email) && /.+@.+/.test(email);
